import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { isToday, isYesterday } from 'date-fns';

@Pipe({
  name: 'acNotificationDate',
  standalone: true,
})
export class NotificationDatePipe implements PipeTransform {
  constructor(
    private readonly _translateService: TranslateService,
    @Inject(LOCALE_ID) private readonly _locale: string
  ) {}

  transform(value: string) {
    if (isToday(new Date(value))) {
      return this._translateService.instant('GENERAL.TODAY', {
        hour: formatDate(value, 'HH:mm', this._locale),
      });
    }
    if (isYesterday(new Date(value))) {
      return this._translateService.instant('GENERAL.YESTERDAY', { hour: formatDate(value, 'HH:mm', this._locale) });
    }
    return formatDate(value, 'dd/MM/yy, HH:mm', this._locale);
  }
}
